import { Drawer } from '@material-ui/core';
import * as React from 'react';
import { useServiceCenter } from '../../../../hooks/use-service-center';
import { FlyoutSaveCancel } from '../../../../components/flyout-components/FlyoutSaveCancel';
import { FlyoutTitle } from '../../../../components/flyout-components/FlyoutTitle';
import { StatusCode } from '../../../../utils/api';
import { TruckRead } from '../../../../transportation/models/trucks/truck-read';
import { TransportationSvc } from '../../../../transportation/service';
import { TruckEditBasicInfo } from '../../../../transportation/components/shipments/TruckEditBasicInfo';

interface IProps {
    visible         : boolean;
    onSuccess       : any;
    onClose         : any;
    truck           : TruckRead;    
}

export const ActionEditTruckInfo = (props: IProps) => {

    const [service]                 = React.useState(new TransportationSvc());
    const userServiceCenter         = useServiceCenter();    
    const [editTruck, setEditTruck] = React.useState<TruckRead>(new TruckRead());
    
    React.useEffect(() => {
        if (props.visible) {    

            const tmpTruck = {...props.truck};
            if (props.truck.id === 0 && props.truck.serviceCenterId.length === 0) {
                tmpTruck.serviceCenterId = userServiceCenter.name === "ALL" ? '' : userServiceCenter.name;
            }

            setEditTruck(tmpTruck);
        }
    }, [props.visible]);

    /**
     * Save the changes to the truck before closing
     */
    const onSaveInfo = async () => {

        if (editTruck) {        
            const result = await service.saveRoute(editTruck);
            if (result.status === StatusCode.Success) {
                setEditTruck(undefined as unknown as TruckRead);
                props.onSuccess(result.data);
            }
        }

    };

    /**
     * Cleanup some our state and close the panel
     */
    const onClose = () => {
        setEditTruck(undefined as unknown as TruckRead);
        props.onClose();
    };

    const handleOnChange = (newTruck : TruckRead) => {
        if (newTruck) {
            setEditTruck({...newTruck});
        }
    };

    return editTruck
            ? <Drawer 
                anchor="right" 
                data-testid="stop-action-basic-info"
                onClose={ onClose }
                open={ props.visible }>
                <div className="stop-action-drawer mini stop-action-basic-info">

                    <FlyoutTitle 
                        onMobileClose={ onClose }
                        title={ editTruck.id > 0 ? "Set Basic Information" : "Create Truck" } />

                    <TruckEditBasicInfo
                        truck={ editTruck }
                        showCompactUI={ true }
                        onTruckChange={ handleOnChange }
                    />
                 
                    <FlyoutSaveCancel
                        onSave={ onSaveInfo }
                        onCancel={ onClose }
                    />

                </div>
        </Drawer>
        : null;
};
